/*jshint esversion: 6 */

/*! webmd debug */
import cookie from 'webmd-cookie';
import { getParam } from 'webmd-url';
let debug;

if (typeof window !== 'undefined') {

  /**
   * Display a message to the console if debug mode is on.
   *
   * <p>Call {@link webmd.debug.activate()} or add the following to the page URL to turn on debug mode: ?webmddebug=1</p>
   *
   * <p>Call {@link webmd.debug.deactivate()} or add the following to the page URL to turn off debug mode: ?webmddebug=0</p>
   *
   * @namespace Display debug messages if debug mode is on.
   * @param {*} o... One or more strings or javascript objects to write to the console
   *
   * @example
   * debug('Hello');
   *
   * @example
   * debug('My object: ', myobject, anotherVariable);
   *
   * @requires url
   * @requires cookie
   */
  debug = function() {

    // Turn arguments into a real array
    let args = Array.prototype.slice.call(arguments);

    if (debug.active && window.console) {

      if (console.log.apply) {
        console.log.apply(console, args);
      } else {
        // Some browsers don't support .apply() for console.log, so just pass an array
        console.log(args);
      }
    }
  };

  Object.assign(debug, {

    active: false,
    cookie: 'webmddebug',
    param: 'webmddebug',

    /**
     * This function runs at page load to determine if webmd.debug() should be active.
     */
    autoDetect: function() {

      // Check for the webmddebug URL parameter
      let param = getParam(this.param);

      if (param === '0') {

        // webmddebug=0 means to deactivate debug mode
        this.deactivate();

      } else if (param === '1' || cookie.exists(this.cookie)) {

        // If webmddebug=1 or if the cookie exists, then activate debug mode
        this.activate();
      }
    },

    /**
     * Turn on webmd.debug messages. Sets a cookie so debug mode will carry through to subsequent pages.
     */
    activate: function() {
      this.active = true;
      cookie.set(this.cookie, '1');
    },

    /**
     * Turn off webmd.debug messages. Removes the cookie so debug mode will stay off on subsequent pages.
     */
    deactivate: function() {
      this.active = false;
      cookie.deleteCookie(this.cookie);
    }

  });

  // Check if we should activate debug messages
  // (if the cookie is set, or the url parameter is set)
  debug.autoDetect();
}

export default debug;